// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__tN6pf","Comment__box":"styles_Comment__box__IA4Y4","Comment__boxGreen":"styles_Comment__boxGreen__dd8sd"};